export default __webpack_public_path__ + "static/media/title-deco-left.03da8012.webp";